export const SET_ACTIVE_BROKER = 'SET_ACTIVE_BROKER';
export interface ActiveBrokerState {
  currentActiveBroker: string | undefined;
}
